import { ItemModel } from '../../../../models/itemModel';
import { WebViewerConfigurations } from './board-web-viewer-configurartions';
import { PDFConfigurations } from './board-pdf-configurations';
import { FormulaConfigurations } from './board-formula-configurations';
import { ImageConfigurations } from './board-image-configurations';
import { VideoConfigurations } from './board-video-configurations';
import { BoardWebViewer } from './board-web-viewer';
import { BoardPdf } from './board-pdf';
import { BoardFormula } from './board-formula';
import { BoardImage } from './board-image';
import { BoardVideo } from './board-video';
import { BoardRemoteVideoConfigurations } from './board-remote-video-configurations';
import { BoardRemoteVideo } from './board-remote-video';
import { BoardChatGptConfigurations } from './board-chat-gpt-configurations';
import { BoardChatGpt } from './board-chat-gpt';
import { BoardQuestionConfigurations } from './board-question-configurations';
import { BoardQuestion } from './board-question';
import { BoardMarioConfigurations } from './board-mario-configurations';
import { BoardMario } from './board-mario';
import { BoardIframeConfigurations } from './board-iframe-configurations';
import { BoardIframe } from './board-iframe';
import { StickyNoteConfigurations } from './board-sticky-note-configurations';
import { BoardStickyNote } from './board-sticky-note';
import { LineConfigurations } from './board-line-configurations';
import { BoardLine } from './board-line';
import { PDFImagesConfigurations } from './board-images-pdf-configurations';
import { BoardImagesPdf } from './board-images-pdf';
import { BoardImagePdf } from './board-image-pdf';

export type ImplementedItemsTypes =
  | ItemModel.WebViewer
  | ItemModel.PDF
  | ItemModel.Formula
  | ItemModel.Image
  | ItemModel.Video
  | ItemModel.RemoteVideo
  | ItemModel.Chat_GPT
  | ItemModel.Question
  | ItemModel.Note
  | ItemModel.Mario
  | ItemModel.IFrame
  | ItemModel.StickyNote
  | ItemModel.Line
  | ItemModel.PDFImages
  | ItemModel.PDFImage;

export const itemConfigConstructors = {
  [ItemModel.WebViewer]: WebViewerConfigurations,
  [ItemModel.PDF]: PDFConfigurations,
  [ItemModel.Formula]: FormulaConfigurations,
  [ItemModel.Image]: ImageConfigurations,
  [ItemModel.Video]: VideoConfigurations,
  [ItemModel.RemoteVideo]: BoardRemoteVideoConfigurations,
  [ItemModel.Chat_GPT]: BoardChatGptConfigurations,
  [ItemModel.Question]: BoardQuestionConfigurations,
  [ItemModel.Note]: BoardQuestionConfigurations,
  [ItemModel.Mario]: BoardMarioConfigurations,
  [ItemModel.IFrame]: BoardIframeConfigurations,
  [ItemModel.StickyNote]: StickyNoteConfigurations,
  [ItemModel.Line]: LineConfigurations,
  [ItemModel.PDFImages]: PDFImagesConfigurations,
  [ItemModel.PDFImage]: ImageConfigurations,
} as const;

export interface ItemModelToConfigurationsMap {
  [ItemModel.WebViewer]: Partial<WebViewerConfigurations>;
  [ItemModel.PDF]: Partial<PDFConfigurations>;
  [ItemModel.Formula]: Partial<FormulaConfigurations>;
  [ItemModel.Image]: Partial<ImageConfigurations>;
  [ItemModel.Video]: Partial<VideoConfigurations>;
  [ItemModel.RemoteVideo]: Partial<BoardRemoteVideoConfigurations>;
  [ItemModel.Chat_GPT]: Partial<BoardChatGptConfigurations>;
  [ItemModel.Question]: Partial<BoardQuestionConfigurations>;
  [ItemModel.Note]: Partial<BoardQuestionConfigurations>;
  [ItemModel.Mario]: Partial<BoardMarioConfigurations>;
  [ItemModel.IFrame]: Partial<BoardIframeConfigurations>;
  [ItemModel.StickyNote]: Partial<StickyNoteConfigurations>;
  [ItemModel.Line]: Partial<LineConfigurations>;
  [ItemModel.PDFImages]: Partial<PDFImagesConfigurations>;
  [ItemModel.PDFImage]: Partial<ImageConfigurations>;
}

export interface ItemModelToBoardItemsMap {
  [ItemModel.WebViewer]: BoardWebViewer;
  [ItemModel.PDF]: BoardPdf;
  [ItemModel.Formula]: BoardFormula;
  [ItemModel.Image]: BoardImage;
  [ItemModel.Video]: BoardVideo;
  [ItemModel.RemoteVideo]: BoardRemoteVideo;
  [ItemModel.Chat_GPT]: BoardChatGpt;
  [ItemModel.Question]: BoardQuestion;
  [ItemModel.Note]: BoardQuestion;
  [ItemModel.Mario]: BoardMario;
  [ItemModel.IFrame]: BoardIframe;
  [ItemModel.StickyNote]: BoardStickyNote;
  [ItemModel.Line]: BoardLine;
  [ItemModel.PDFImages]: BoardImagesPdf;
  [ItemModel.PDFImage]: BoardImagePdf;
}

export type Configurations = PDFConfigurations &
  WebViewerConfigurations &
  FormulaConfigurations &
  VideoConfigurations &
  BoardRemoteVideoConfigurations &
  BoardChatGptConfigurations &
  BoardQuestionConfigurations &
  BoardMarioConfigurations &
  BoardIframeConfigurations &
  StickyNoteConfigurations &
  LineConfigurations &
  PDFImagesConfigurations;
